import { css } from '@emotion/react'
import {
  PerkCardBox,
  PerkCardPaddingWrapper,
  SIconWrapper,
  SLinkText,
  SText,
  StyledBadge,
} from './PerkCard.styled'
import { Icon } from 'components/icon'
import { HStack, Stack } from 'components/Stack'
import { Caption, Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ReactNode } from 'react'
import { colors } from 'utils/colors'

const PerkCard = ({
  type,
  icon,
  title,
  href,
  perks,
}: {
  type: 'free' | 'premium'
  icon: ReactNode
  title: string
  href: string
  perks?: JSX.Element[]
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const isCurrentPage = router.pathname.match(`${href}$`)

  return (
    <PerkCardBox space={'1rem'}>
      <PerkCardPaddingWrapper space="1rem">
        <SIconWrapper>{icon}</SIconWrapper>
        <StyledBadge type={type}>
          <Caption>{t(`common.section_digital_protection_perks.caption_${type}`)}</Caption>
        </StyledBadge>
        <SText variant="bodyBold" color={colors.gray[100]}>
          {title}
        </SText>
        <Stack space={'0.75rem'}>
          {perks?.map((perk, i) => (
            <HStack key={i}>
              <Icon
                name="Check"
                color={colors.green[200]}
                size="0.75rem"
                css={css`
                  flex-shrink: 0;
                `}
              />
              <Text color={colors.black}>{perk}</Text>
            </HStack>
          ))}
        </Stack>
      </PerkCardPaddingWrapper>
      <Link href={href} legacyBehavior>
        <SLinkText variant="bodyMedium" hide={!!isCurrentPage}>
          {t('common.section_digital_protection_perks.link_title')}
        </SLinkText>
      </Link>
    </PerkCardBox>
  )
}

export default PerkCard
